import { useState, useCallback } from 'react';

// Tracks image URLs that failed to load (404, deleted file, etc.) so callers
// can swap in a placeholder instead of leaving a broken-image icon on screen.
export const useFailedImages = () => {
    const [failed, setFailed] = useState(() => new Set());
    const markFailed = useCallback((src) => {
        setFailed(prev => (prev.has(src) ? prev : new Set(prev).add(src)));
    }, []);
    return [failed, markFailed];
};
